import { render, staticRenderFns } from "./proofTable.vue?vue&type=template&id=f3ebde76"
import script from "./proofTable.vue?vue&type=script&lang=js"
export * from "./proofTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports